import React, { type FC } from 'react';
import { Button, Space } from '@g2u/ui-kit';

import { type WithOptionalDataTest } from 'types';

export namespace Actions {
  export type Props = {
    onConfirm: () => void;
    onCancel: () => void;
    isCreating: boolean;
    isActive: boolean;
  } & WithOptionalDataTest;

  export const $: FC<Props> = (props) => {
    const { onConfirm, onCancel, isCreating, isActive } = props;

    return (
      <Space.$ direction={Space.Direction.Horizontal} justify={Space.Justify.End} size={Space.Size.Middle}>
        <Button.$ dataTestId="cancel-btn" type={Button.Type.Default} danger onClick={onCancel} disabled={isCreating}>
          Cancel
        </Button.$>

        <Button.$
          dataTestId="confirm-btn"
          type={Button.Type.Primary}
          onClick={onConfirm}
          loading={isCreating}
          disabled={!isActive}
        >
          Confirm
        </Button.$>
      </Space.$>
    );
  };
}
